export const compareWithTextSensitivity = (
  first: string | number,
  second: string | number,
  sortRule: "asc" | "desc" = "asc",
) => {
  const compareNumber = first
    .toString()
    .toLocaleLowerCase()
    .localeCompare((second || "").toString().toLocaleLowerCase(), undefined, {
      numeric: true,
      sensitivity: "base",
    });

  return sortRule === "asc" ? compareNumber : -compareNumber;
};
